<div class="uk-card uk-card-default uk-card-body uk-width-1-2@m">
  <h3 class="uk-card-title">Compte crée</h3>
  <p>
    Vos identifiants de connexion vous ont été envoyé par mail
    <ng-container *ngIf="email">à l'adresse suivante : <strong>{{ email }}</strong></ng-container>
  </p>
  <button kendoButton [primary]="true"
          (click)="goToHomePage()">
    Retour à la page principale
  </button>
</div>
